
import React, {FC, RefObject, useRef} from 'react';
import {useAspectRatio} from 'templates/reports/Section/ScanImages/useAspectRatio';

import DownIcon from './svgs/down.inline.svg';

import * as styles from './styles.module.scss';

type DownloadProps = {
	canvas: RefObject<HTMLCanvasElement>
}

const Download: FC<DownloadProps> = ({canvas}) => (
	<div className={styles.download} onClick={onSave(canvas)}>
		<DownIcon /> Download
	</div>
);

type SaveImageProps = {
	title: string
	children: (canvas: RefObject<HTMLCanvasElement>) => React.ReactNode
}

const onSave = (canvas: React.RefObject<HTMLCanvasElement>) => () => {
	const orig = canvas.current;
	if (!orig) {
		return;
	}

	// Calculate desired output aspect ratio
	const ar = useAspectRatio(orig);
	const width = 300;
	const height = Math.round(width / ar.aspectRatio);

	// Create canvas copy so we can resize
	const copy = document.createElement('canvas');
	copy.width = width;
	copy.height = height;

	// Draw the original canvas mapped onto the new size
	const ctx = copy.getContext('2d');
	ctx?.drawImage(orig, 0, 0, orig.width, orig.height, 0, 0, width, height);

	// Create a link that automatically downloads
	const link = document.createElement('a');
	link.setAttribute('download', 'scan-image.png');

	// Populate link with image data and trigger click
	copy.toBlob((blob) => {
		if (blob) {
			const url = URL.createObjectURL(blob);
			link.setAttribute('href', url);
			link.click();
		}
	});
};

const SaveImage: FC<SaveImageProps> = ({title, children}) => {
	const canvas = useRef<HTMLCanvasElement>(null);
	return (
		<div className={styles.image}>
			<span>{title}</span>
			{children(canvas)}
			<Download canvas={canvas} />
		</div>
	);
};

export default SaveImage;
